import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import { StyledStickyHeader } from "./sticky-header.scss";
import PictureComponent from "/components/core/picture/picture-component";
import { circlesData } from "./consts";
import Colors from "/styles/colors";
import { BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02, WHITE_COLOR_NAME } from "styles/color-consts";
import { trackEvent } from "/services/bigbrain-service";
import { STICKY_HEADER_CIRCLE_CLICKED, STICKY_HEADER_CIRCLE_HOVERED, STICKY_HEADER_IS_VISIBLE } from "/constants/bigbrain-event-types";
const StickyHeader = (props)=>{
    const { translate, startShowingStickyHeader } = props;
    const [activeCircle, setActiveCircle] = useState(null);
    const [visibleCircle, setVisibleCircle] = useState(null);
    useEffect(()=>{
        if (startShowingStickyHeader) {
            trackEvent(STICKY_HEADER_IS_VISIBLE);
        }
        const handleScroll = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const visibleSection = circlesData.find((circle)=>circle.id === entry.target.id);
                    if (visibleSection) {
                        setVisibleCircle(visibleSection.id);
                    }
                }
            });
        };
        const observer = new IntersectionObserver(handleScroll, {
            root: null,
            threshold: 0.5
        });
        circlesData.forEach((circle)=>{
            const target = document.getElementById(circle.id);
            if (target) {
                observer.observe(target);
            }
        });
        return ()=>{
            circlesData.forEach((circle)=>{
                const target = document.getElementById(circle.id);
                if (target) {
                    observer.unobserve(target);
                }
            });
        };
    }, [
        startShowingStickyHeader
    ]);
    const handleCircleClick = (id)=>{
        const targetElement = document.getElementById(id);
        if (targetElement) {
            const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - 100;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
        trackEvent(STICKY_HEADER_CIRCLE_CLICKED, {
            info1: id
        });
        setActiveCircle(null);
    };
    const handleCircleHover = (id)=>{
        setActiveCircle(id);
        trackEvent(STICKY_HEADER_CIRCLE_HOVERED, {
            info1: id
        });
    };
    return /*#__PURE__*/ _jsx(StyledStickyHeader, {
        children: circlesData.map((circle)=>/*#__PURE__*/ _jsxs("div", {
                className: activeCircle === circle.id ? "expanded-circle" : "circle",
                onMouseEnter: ()=>handleCircleHover(circle.id),
                onMouseLeave: ()=>setActiveCircle(null),
                onClick: ()=>handleCircleClick(circle.id),
                style: {
                    backgroundColor: visibleCircle === circle.id ? Colors[BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02] : Colors[WHITE_COLOR_NAME]
                },
                children: [
                    /*#__PURE__*/ _jsx(PictureComponent, {
                        src: circle.image
                    }),
                    activeCircle === circle.id && /*#__PURE__*/ _jsx("div", {
                        className: "circle-text",
                        children: translate(circle.label)
                    })
                ]
            }, circle.id))
    });
};
export default withGenericConfig(StickyHeader);
